/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
'use strict';

/*
* A directive that will customize the a radio button to make it more of a bulb style.
* In order to use correctly: create an input of type 'radio' and append the directive as an attribute
* Then create a label as a direct sibling of the input.
*/
angular.module('bulbApp.radiobuttonModule')
.directive('bulbRadiobutton', bulbRadiobutton);

function bulbRadiobutton() {
  return {
    restrict: 'A',
    replace: true,
    compile: function() {
      return {
        pre: function(scope, element){
          element.wrap('<label class="bulb-radiobutton"></label>');
        }
      };
    }
  };
}
